module.exports = __webpack_public_path__ + "static/get-involved-3c3f415c45a11fa95281bf27af241f86.jpg";